module.exports = __webpack_public_path__ + "img/development-charter.2a93cdf2.svg";